import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import FacultyData from '../../Assets/JSON/MV.json'
import HS from '../../Pages/HS/HS'
import { Button, Grid, Typography, Box, useTheme } from '@mui/material'
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material'
import {
  IMAGE_BASE_PATH_COMMON,
  IMAGE_BASE_PATH_DBRALC,
} from '../../Config/Config'

const Faculty = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const [hoveredFaculty, setHoveredFaculty] = useState(null)

  const handleViewProfile = (index) => {
    const faculty = FacultyData.FacultyData.Faculty[index]
    navigate(`/faculty/${faculty.id}/${faculty.Name}`, {
      state: { selectedDocData: faculty },
    })
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 3 },
        minHeight: '100vh',
      }}
      className="container"
    >
      <Box sx={{ maxWidth: '1400px', mx: 'auto' }}>
        {/* Header Section */}
        <Box sx={{ mb: 8, textAlign: 'center' }}>
          <Typography component="div" sx={{ mb: 5 }}>
            <HS HS_DATA={FacultyData.HOD_Message} />
          </Typography>
        </Box>

        {/* Faculty Grid */}
        <Grid container spacing={4}>
          {FacultyData?.FacultyData?.Faculty.map((faculty, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={faculty.Name}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  cursor: 'pointer',
                }}
                onClick={() => handleViewProfile(index)}
              >
                {/* Image Container */}
                <Box
                  onMouseEnter={() => setHoveredFaculty(index)}
                  onMouseLeave={() => setHoveredFaculty(null)}
                  sx={{
                    position: 'relative',
                    width: { xs: '100%', sm: '80%', md: '190px' },
                    aspectRatio: '1 / 1.1',
                    borderRadius: 2,
                    overflow: 'hidden',
                    mb: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={
                      faculty.image === ''
                        ? IMAGE_BASE_PATH_COMMON +
                          'Placeholders/Placeholder_Image.jpg'
                        : IMAGE_BASE_PATH_DBRALC + faculty.image
                    }
                    alt={faculty.Name}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'filter 0.4s ease',
                    }}
                  />

                  {/* Hover Button Overlay */}
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: hoveredFaculty === index ? '100%' : '0%',
                      background:
                        hoveredFaculty === index
                          ? `linear-gradient(to top, rgba(198, 71, 21, 0.80), transparent)`
                          : 'transparent',
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'center',
                      pb: 2,
                      transition: 'all 0.3s ease',
                      overflow: 'hidden',
                    }}
                  >
                    <Button
                      variant="contained"
                      endIcon={
                        <ArrowForwardIcon
                          sx={{
                            transform: 'rotate(-45deg)',
                            fontSize: '1.2rem',
                          }}
                        />
                      }
                      sx={{
                        transform:
                          hoveredFaculty === index
                            ? 'translateY(0)'
                            : 'translateY(70px)',
                        opacity: hoveredFaculty === index ? 1 : 0,
                        transition: 'all 0.3s ease 0.1s',
                        color: 'white',
                        backgroundColor: 'transparent',
                        fontWeight: 600,
                        boxShadow: 'none',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          color: 'white',
                          boxShadow: 'none',
                        },
                      }}
                    >
                      View Profile
                    </Button>
                  </Box>
                </Box>

                {/* Faculty Info */}
                <Box sx={{ textAlign: 'left' }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 500,
                      color: theme.palette.text.primary,
                      fontSize: {
                        xs: '0.85rem', // Extra small devices
                        sm: '0.9rem', // Small devices
                        md: '0.95rem', // Medium devices
                        lg: '1rem', // Large devices
                        xl: '1.05rem', // Extra large devices
                      },
                      lineHeight: 1.3,
                      mb: 0.5,
                    }}
                  >
                    {faculty.Name}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.primary.main,
                      fontWeight: 400,
                      fontSize: {
                        xs: '0.75rem',
                        sm: '0.8rem',
                        md: '0.85rem',
                        lg: '0.9rem',
                        xl: '0.95rem',
                      },
                      lineHeight: 1.2,
                      letterSpacing: '0.02em',
                    }}
                  >
                    {faculty.designation}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}

export default Faculty
